import { EnumOption } from "./enum-option"

export const MatterEVLStatus = {
    NotComplete: 0,
    Complete: 1,
}

export const MatterEVLStatusList: EnumOption[] = [
    { value: MatterEVLStatus.NotComplete, label: 'Not Complete' },
    { value: MatterEVLStatus.Complete, label: 'Complete' },
]
